import { environment, formatDate,getOnlineServices,getPlatformFromUserAgent, HEADER_ENAEP} from "../util/index";
import { useDispatch, useSelector } from "react-redux";
import { useFetchService } from "./useFetchService";
import { IADPState, LaunchErrorType } from "../typings/AppStateTypes";
import { LaunchErrorRequest } from "../typings/ServiceTypes";
import { indexDBStorage } from "../storage/indexDBStorage";

export function useLaunchErrorService() {
  const {fetch} = useFetchService();
  const state = useSelector((state:{rootState:IADPState}) => state.rootState)
  const sendErrorLog = (errorType:LaunchErrorType,errorDetails:unknown) =>{
    const payload = createErrorLogPayload(errorType,errorDetails)
    const onlineServiceConfig = getOnlineServices(state.appState.configuration);
    const url = `${environment.resolveApiDomain(state.appState.configuration)}/${onlineServiceConfig?.softwareStatus}`;
      fetch(url,{headers:HEADER_ENAEP,method: "POST",body:JSON.stringify(payload)},"NoError",[],true).then(async (response)=>{
          if(response){
            console.info("[LaunchError launch error log posted");
          }
          else {
          console.error("[LaunchError] failed to post launch error log");
          (await indexDBStorage.getInstance()).transactions.put("adp-session-references",({payload:payload, error:"failed to post launch error log"}),`Launch_Error_${errorType}_${formatDate(new Date(),true)}`); 
          }
        });
  }
  const createErrorLogPayload =(errorType:LaunchErrorType,errorDetails:unknown)=> {
      const payload: LaunchErrorRequest = {
      context:{
        path: `diagnostic/ng-enaep-student-app/${state.deviceState?.deviceType?.toLocaleLowerCase() || "sbe"}/p2/launch-error/${formatDate(new Date())}` ,  
        fileName:`Launch_Error_${errorType}_${formatDate(new Date(),true)}.json`,  
      },
        data:{
        schemaVersion: '3.0.3',
        releaseVersion: state.appState?.releaseVersion || "NotAvailable",
        buildNumber: state.appState?.releaseBuildNumber.toString() || "NotAvailable",
        appVersion: state.appState?.appVersion || "NotAvailable",
        appType: 'ng-enaep-student-app',
        appName: 'ng-enaep-adp-pwa',
        deviceDetails: {
          deviceType:state.deviceState?.deviceType || "SBE",
          deviceName: state.deviceState?.deviceId  || "Chromebook",
          deviceModel: state.deviceState?.deviceModel  || "Chromebook",
          deviceIdType: state.deviceState?.deviceIdType || "NotAvailable",
          operatingSystem: getPlatformFromUserAgent(),
          hostingPlatform: state.appState.runtimePlatform
        },
        sessionDetails: {
          clientLaunchId: state.appState?.appLaunchId || "NotAvailable",
          adpLaunchDateTime:new Date(state.appState.appLaunchTime) || "NotAvailable",
          setupCode:'NotAvailable',
          verificationCode: "NotAvailable",
          appAccessedFor: "NotSelected",
          participantId: 'NotAvailable',
          assessmentDeliveryMode: state.sessionState?.selectedAssessmentMode || "NotAvailable",
          connectionType:state.deviceState.deviceType === "SBE" ? "Internet": "NPN",
          serverDetails: environment.resolveApiDomain(state.appState.configuration),
        },
        launchError: {
          errorType: errorType,
          errorDetails: errorDetails
        } 
      }
      }
      
      return payload;
    
  }
  return {sendErrorLog}
}